export default "__VITE_ASSET__3ebdbac9__"